module.exports = __webpack_public_path__ + "static/media/bg.e9266929.png";